import { MenuAction } from "./menu.types";

export const menuOpenAction = (): MenuAction => ({ type: 'MENU_OPEN' })
export const menuCloseAction = (): MenuAction => ({ type: 'MENU_CLOSE' })

export const menuOpenedKeysSetAction = (keys: string[]): MenuAction => ({ type: 'MENU_OPENED_KEYS_SET', params: keys })

export const menuCurrentItemSetAction = (name?: string): MenuAction => ({ type: 'MENU_CURRENT_ITEM_SET', params: name })